import { Zap, RotateCcw, Aperture } from "lucide-react";

export default function CameraScreen({ image }) {
  return (
    <div className="relative flex h-full flex-col bg-neutral-950 text-white">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-black/30" />

      {/* Top controls */}
      <div className="relative flex items-center justify-between px-4 pt-10">
        <span className="rounded-full bg-black/50 px-2 py-1 text-[9px] uppercase tracking-wider">HDR</span>
        <span className="rounded-full bg-black/50 px-2 py-1 text-[9px] uppercase tracking-wider">4:3</span>
        <Zap className="h-3.5 w-3.5" strokeWidth={1.5} />
      </div>

      {/* Modes */}
      <div className="absolute bottom-24 left-0 right-0">
        <div className="flex justify-center gap-4 text-[9px] uppercase tracking-[0.15em] text-white/60">
          <span>Slo-mo</span>
          <span>Video</span>
          <span className="text-amber-300">Photo</span>
          <span>Portrait</span>
          <span>Pano</span>
        </div>
      </div>

      {/* Shutter row */}
      <div className="absolute bottom-6 left-0 right-0 flex items-center justify-around px-6">
        <div className="h-10 w-10 rounded-lg border border-white/40 bg-black/30" />
        <div className="grid h-16 w-16 place-items-center rounded-full border-4 border-white">
          <Aperture className="h-8 w-8 text-white" strokeWidth={1.2} />
        </div>
        <div className="grid h-10 w-10 place-items-center rounded-full bg-white/10">
          <RotateCcw className="h-4 w-4" strokeWidth={1.5} />
        </div>
      </div>
    </div>
  );
}
